import React, { Component } from 'react';
import logo from "../images/logo.png"
import arrow from "../images/arrow.png"
import close from "../images/close.png"
import Ionicon from 'react-ionicons'
import { Link } from 'react-scroll'

class imageFullScreen extends Component {

  constructor(props){
    super(props)
    this.state = {
      width: document.documentElement.offsetWidth
    }
  }

  componentDidMount(){
    window.addEventListener("resize", this.resize.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener("resize", this.resize.bind(this));
  }

  resize(){
    this.setState({
      width:document.documentElement.offsetWidth
    })
  }

  render() {

    const width = this.state.width
    var y = 0
    if(width < 800){
      y = -60
    }

    return (
      <div id="imageFullScreen" className="imageFullScreen">
        <div className="containerCenter">
        <div>

          <img src={logo} alt="logo petit déj"/>
        </div>
        <div className="icon">
          <img src={close} alt="close"/>
        </div>
        <Link to="concept" spy={true} smooth={true} offset={y} duration={500}>
          <button>En savoir plus</button>
        </Link>
        </div>
      </div>
    )
  }

}


export default imageFullScreen;



// WEBPACK FOOTER //
// ./src/client/components/imageFullScreen.js